// extracted by mini-css-extract-plugin
module.exports = {"question":"faq_question__3fv9Z","panel":"faq_panel__2t4oM"};